<template>
  <page-edicion>
    <page-header :title="cliente.razonSocial" :subtitle="`Contrato para ${oferta.codigo}`" back-to="/contratos" />
    <formulario-contrato-cliente
      :contrato-cliente="contratoCliente"
      :pais="pais"
      :opciones-paises="paises"
      :cliente="cliente"
      :unidad-negocio="unidadNegocio"
      :campania="campania"
      :plan="plan"
      :divisa="divisa"
      :oferta="oferta"
      :oferta-modulos="soloModulos"
      :oferta-servicios="soloServicios"
      :anexos="anexos"
      @submit="actualizar"
      @eliminarAnexos="eliminarAnexos"
    />
  </page-edicion>
</template>

<script>
import FormularioContratoCliente from "./FormularioContratoCliente.vue";
import api from "@/services/contratosCliente.js";
import * as paisesApi from "@/services/paises.js";
import * as divisasApi from "@/services/divisas.js";
import * as clientesApi from "@/services/clientes.js";
import campaniasApi from "@/services/campanias.js";
import planesApi from "@/services/planes.js";
import * as unidadesNegocioApi from "@/services/unidadesNegocio.js";
import contratosClienteApi from "@/services/contratosCliente.js";
import * as ofertasApi from "@/services/ofertas";
import * as TipoModulo from "@/enums/TipoModulo";

export default {
  components: { FormularioContratoCliente },
  data() {
    return {
      contratoCliente: contratosClienteApi.crear(),
      paises: [],
      pais: paisesApi.crear(),
      cliente: clientesApi.crear(),
      unidadNegocio: unidadesNegocioApi.crear(),
      campania: campaniasApi.crear(),
      plan: planesApi.crear(),
      paisesId: [],
      opcionesPaises: [],
      opcionesClientes: [],
      divisa: divisasApi.crear(),
      oferta: ofertasApi.crearOferta(),
      ofertaModulos: [],
      modulos: [],
      anexos: [],
      anexosEliminar: [],
    };
  },
  computed: {
    soloModulos() {
      return this.ofertaModulos.filter((x) => this.modulos[x.moduloId].tipo != TipoModulo.SERVICIO);
    },
    soloServicios() {
      return this.ofertaModulos.filter((x) => this.modulos[x.moduloId].tipo == TipoModulo.SERVICIO);
    },
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    async cargar(id) {
      var data = await api.cargar(id);
      this.contratoCliente = data.contratoCliente;
      this.anexos = data.anexos;
      await this.cargarCliente(data.contratoCliente.clienteId);
      await this.cargarPais(data.contratoCliente.paisId);
      if (data.contratoCliente.unidadNegocioId) {
        await this.cargarUnidadNegocio(data.contratoCliente.unidadNegocioId);
      }
      await this.cargarCampania(data.contratoCliente.campaniaId);
      await this.cargarPlan(data.contratoCliente.planId);
      await this.cargarPaises(data.contratoCliente.unidadNegocioId);
      await this.cargarDivisas(data.contratoCliente.divisaId);
      if (data.contratoCliente.ofertaId) {
        await this.cargarOferta(data.contratoCliente.ofertaId);
      }
    },
    actualizar(anexosDatos) {
      if (this.contratoCliente.ofertaId == 0) {
        this.contratoCliente.ofertaId = null;
      }
      if (this.contratoCliente.ofertaRenovacionId == 0) {
        this.contratoCliente.ofertaRenovacionId = null;
      }
      if (this.contratoCliente.contratoOrigenId == 0) {
        this.contratoCliente.contratoOrigenId = null;
      }
      var contratoCliente = {
        contratoCliente: this.contratoCliente,
        eliminarAnexos: this.anexosEliminar,
        ficherosAnexos: anexosDatos,
      };
      api.actualizar(contratoCliente).then(() => {
        this.cargar(this.$route.params.id);
      });
    },
    async cargarCliente(id) {
      const data = await clientesApi.cargar(id, false);
      this.cliente = data.cliente;
    },
    async cargarPais(id) {
      const data = await paisesApi.cargar(id);
      this.pais = data.pais;
    },
    async cargarUnidadNegocio(id) {
      const data = await unidadesNegocioApi.cargar(id);
      this.unidadNegocio = data.unidadNegocio;
    },
    async cargarCampania(id) {
      const data = await campaniasApi.cargar(id);
      this.campania = data.campania;
    },
    async cargarPlan(id) {
      const data = await planesApi.cargar(id);
      this.plan = data.plan;
    },
    async cargarPaises(unidadNegocioId) {
      this.paises = await unidadesNegocioApi.obtenerPaises(unidadNegocioId);

      if (this.paises.length) {
        this.contratoCliente.paisId = this.paises[0].id;
      }
    },
    async cargarDivisas(id) {
      const data = await divisasApi.cargar(id);
      this.divisa = data.divisa;
    },
    async cargarOferta(id) {
      const data = await ofertasApi.cargarCompleta(id);
      this.oferta = data.oferta;
      this.ofertaModulos = data.ofertaModulos;
      this.modulos = data.modulos;
    },
    eliminarAnexos(anexosActualizados, contratoClienteAnexoId) {
      this.anexos = anexosActualizados;
      this.anexosEliminar.push(contratoClienteAnexoId);
    },
  },
};
</script>
